export default "__VITE_ASSET__P4AlPueE__"